import { on, select, removeClass, addClass } from 'modules/dom'

const SELECTOR_FORM = '.js-newsletter__form'
const SELECTOR_INPUT = '.js-newsletter__input'
const CLASS_FORM_ERR0R = 'newsletter__form--error'

function NewsLetter (el) {
  var t = this
  t.el = el
  t.form = select(SELECTOR_FORM, el)
  t.input = select(SELECTOR_INPUT, el)
  t.init()
}

NewsLetter.prototype.init = function () {
  var t = this
  on('submit', t.validateForm, t.form)
}

NewsLetter.prototype.validateForm = function (event) {
  event.preventDefault()
  const target = event.target
  const input = select(SELECTOR_INPUT, target)
  const valueInput = input.value
  if (validateEmpty(valueInput) || !validateEmail(valueInput)) {
    addClass(CLASS_FORM_ERR0R, target)
  } else {
    removeClass(CLASS_FORM_ERR0R, target)
  }
  return false
}

const validateEmail = function (email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

const validateEmpty = function (string) {
  return (string.length === 0 || !string.trim())
}

export default NewsLetter
